import { useQuery } from '@tanstack/react-query';
import type { ApiResponse } from '../../@types/ApiResponse';
import type { Permission } from '../../@types/Permission';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import { getJSON } from '../../fetch';
import useAuth from '../../hooks/useAuth';
import useBranch from '../branch/useBranch';

export const PERMISSIONS_QUERY = '/api/permissions/:market/:branchId';

const usePermissions = (): [Permission | undefined, RequestStateQuery] => {
  const { getToken } = useAuth();
  const [branch] = useBranch();

  const { data, isLoading, isSuccess, isError } = useQuery<ApiResponse<Permission>>({
    queryKey: [PERMISSIONS_QUERY, branch?.id],
    queryFn: async () =>
      await getJSON<ApiResponse<Permission>>(
        `/api/permissions/${branch?.marketCode}/${branch?.id}`,
        getToken()!,
      ),
    enabled: !!branch?.id,
  });

  return [data?.response, { isLoading, isSuccess, isError }];
};

export default usePermissions;
